import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Loader } from 'semantic-ui-react';
import LineChart from 'components/common/charts/LineChart/Container';
import {
  blueColor,
  greenColor,
  orangeColor,
} from 'utils/chartColors';
import currencyFormat from 'utils/currencyFormat';
import todaysDate from 'utils/todaysDate';
import toMonthStat from 'helpers/toMonthStat';
import walletGrowthLabel, {
  walletChartData,
} from 'helpers/walletGrowthLabel';

import './index.scss';

const SingleIndividualWalletChart = ({
  individualWallet,
  monthlyBalances,
  filterYear,
  loading,
}) => {
  const { balance = 0, cash_in: cashIn = 0, cash_out: cashOut = 0 } =
    individualWallet || {};

  const balances = monthlyBalances || [];

  const balanceData = walletChartData(balances, 'balance');
  const cashInData = walletChartData(balances, 'cash_in');
  const cashOutData = walletChartData(balances, 'cash_out');

  const growthLabel = key => walletGrowthLabel(balances, key);

  if (loading) {
    return (
      <div
        className="flex align-center justify-center"
        style={{ height: 300 }}
      >
        <Loader active inline="centered" />
      </div>
    );
  }

  return (
    <div className="individual-wallet-charts">
      <Grid columns={3}>
        <Grid.Row stretched>
          <Grid.Column>
            <LineChart
              title="Wallet Balance"
              date={todaysDate(filterYear)}
              subtitle={growthLabel('balance')}
              amount={currencyFormat(balance)}
              data={toMonthStat(balanceData)}
              background={blueColor}
              dataKey="total"
              color="#fff"
            />
          </Grid.Column>
          <Grid.Column>
            <LineChart
              title="Cash In Transactions"
              date={todaysDate(filterYear)}
              subtitle={growthLabel('cash_in')}
              amount={currencyFormat(cashIn)}
              data={toMonthStat(cashInData)}
              background={greenColor}
              dataKey="total"
              color="#fff"
            />
          </Grid.Column>
          <Grid.Column>
            <LineChart
              title="Cash Out Transactions"
              date={todaysDate(filterYear)}
              subtitle={growthLabel('cash_out')}
              amount={currencyFormat(cashOut)}
              data={toMonthStat(cashOutData)}
              background={orangeColor}
              dataKey="total"
              color="#fff"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

SingleIndividualWalletChart.defaultProps = {
  individualWallet: null,
  monthlyBalances: [],
  filterYear: null,
  loading: false,
};

SingleIndividualWalletChart.propTypes = {
  filterYear: PropTypes.number,
  loading: PropTypes.bool,
  individualWallet: PropTypes.shape({
    balance: PropTypes.number,
    cash_in: PropTypes.number,
    cash_out: PropTypes.number,
  }),
  monthlyBalances: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string,
      cash_in: PropTypes.number,
      cash_out: PropTypes.number,
      balance: PropTypes.number,
    }),
  ),
};

export default SingleIndividualWalletChart;
